import {
    getMappingSymbol,
    getShapeAttr,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/chart-component/utils/style';
import type { Marker as G2Marker } from '@tencent/chart/lib/antv/g2/interface';
import type {
    IMarkerProperty,
} from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart/geometry/marker/marker.interface';
import type {
    ChartUIMarker,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/chart-component/interface/chart-ui.interface';

export const DEFAULT_SYMBOL: G2Marker = 'circle';

export class Marker {
    public constructor(private marker: IMarkerProperty) {}

    public getConfig(): ChartUIMarker {
        const { marker } = this;

        return {
            symbol: getMappingSymbol(marker.symbol),
            size: marker.size,
            ...getShapeAttr(marker.props),
        };
    }
}
